import { Box } from "@mui/material";

/** Thin drag-to-resize divider between the canvas and a side panel. */
export default function ResizeHandle({ onPointerDown }: { onPointerDown: (e: React.PointerEvent) => void }) {
  return (
    <Box
      onPointerDown={onPointerDown}
      sx={{
        width: "5px",
        flexShrink: 0,
        cursor: "col-resize",
        bgcolor: "transparent",
        "&:hover": { bgcolor: "action.hover" },
        "&:active": { bgcolor: "action.selected" },
      }}
    />
  );
}
